import { render, staticRenderFns } from "./FleetImportArea.vue?vue&type=template&id=2762a94a&scoped=true&"
import script from "./FleetImportArea.vue?vue&type=script&lang=js&"
export * from "./FleetImportArea.vue?vue&type=script&lang=js&"
import style0 from "./FleetImportArea.vue?vue&type=style&index=0&id=2762a94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2762a94a",
  null
  
)

export default component.exports